import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// Vendor Components
import sanityClient from '../../sanity-client.js';
import imageUrlBuilder from '@sanity/image-url';
import { isMobile } from 'react-device-detect';

// Components
import { Row, Col, Container } from 'react-bootstrap';
import HorizontalLineIcon from '../../components/HorizontalLineIcon';
import HorizontalLine from '../../components/HorizontalLine';
import MasonryGrid from '../../components/MasonryGrid';
import Loading from '../../components/Loading';

// Styles
import './style.scss';

const builder = imageUrlBuilder(sanityClient);

function urlFor(source) {
  if (isMobile) {
    return builder.image(source).width(640).format('webp');
  }
  return builder.image(source).format('webp');
}

function blocksToText(blocks) {
  return blocks.map((block) => block.children.map((child) => child.text));
}

const SanityPages = () => {
  const { slug } = useParams();
  const [postData, setPostData] = useState(null);

  useEffect(() => {
    sanityClient
      .fetch(
        `* [slug.current == "${slug}"] {
					title,
					mainImage {
						asset -> {
							_id,
							url,
							metadata {
								dimensions {
									aspectRatio
								},
								lqip
							},
						},
						title,
						altTag,
						titleColour,
					},
					slug,
					albums[] {
						asset -> {
							_id,
							url,	
							metadata{
								dimensions {
									aspectRatio
								},
								lqip
							}
						},
						title,
						subTitle,
						alt,
					},
					storyTitle,
					story,
					masonry[] {
						asset -> {
							_id,
							url,
							metadata {
								dimensions {
									aspectRatio
								},
								lqip
							},
						},
						title,
						alt,
					}
				}`
      )
      .then((data) => setPostData(data[0]))
      // .then((data) => setPostData({ ...postData, data: data[0], location: slug }))
      .catch(console.error);
  }, [slug]);

  if (!postData) return <Loading />;

  return (
    <Container className={`px-0 overflow-hidden ${slug}`} fluid id="sanityPage">
      <Row as="header">
        {postData.mainImage && (
          <div
            className="col hero__container lqip"
            style={{
              backgroundImage: `url(${postData.mainImage.asset.metadata.lqip})`
            }}
          >
            <img src={urlFor(postData.mainImage.asset).url()} alt={postData.mainImage.altTag} />
            <div className="header__title" style={{ color: `${postData.mainImage.titleColour}` }}>
              {postData.mainImage.title}
            </div>
          </div>
        )}
      </Row>

      <main>
        {postData.albums && (
          <Container as="section">
            <Row className="album__grid">
              {postData.albums.map((album, index) => {
                return (
                  <Col key={index} className="album" lg={4} md={6} sm={6} xs={6}>
                    <div className="album__wrap">
                      <div
                        className="image__wrap lqip"
                        style={{
                          backgroundImage: `url(${album.asset.metadata.lqip})`
                        }}
                      >
                        <div className="image" style={{ backgroundImage: `url("${urlFor(album.asset).url()}")` }}></div>
                      </div>
                      <a href="https://markaustin.dev/" className="album__info link--gold">
                        {album.title}
                        <HorizontalLine />
                        <span> {album.subTitle}</span>
                      </a>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </Container>
        )}

        <Container as="section">
          <div className="row photoshoot__info">
            <div className="col">
              {postData.storyTitle && <h2 className="photoshoot__title">{postData.storyTitle}</h2>}
              {postData.story && blocksToText(postData.story)}
            </div>
          </div>
        </Container>

        <Container as="section">
          <HorizontalLineIcon />
        </Container>

        <Container as="section">{postData.masonry && <MasonryGrid show={postData.masonry} />}</Container>
      </main>
    </Container>
  );
};

export default SanityPages;
